export const config = {
  WebSocket: process.env.REACT_APP_WS || "",
};
